// Toggle inline filters visibility
document.addEventListener('click', (event) => {
  const filterButton = event.target.closest('.filters-button');
  if (filterButton) {
    event.preventDefault();
    event.stopPropagation();
    
    // Find the inline-filters element in the same parent container
    const parentContainer = filterButton.closest('.collection-actions');
    if (parentContainer) {
      const inlineFilters = parentContainer.querySelector('.inline-filters');
      if (inlineFilters) {
        const isVisible = inlineFilters.classList.toggle('is-visible');
        // Toggle the button state and change caret character
        filterButton.classList.toggle('is-open', isVisible);
        const caret = filterButton.querySelector('.filter-caret');
        if (caret) {
          caret.textContent = isVisible ? '<' : '>';
        }
      }
    }
  }
});

